var repairsInit = function() {

    // Squares Proportions fixed to Square
    var width = $('[data-shape="square"]').width();
    $('[data-shape="square"]').height(width);

    var delay = (function () {
        var timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();

    // Keep list the same height

    function equalHeight(group) {
        tallest = 0;
        group.each(function () {
            thisHeight = $(this).height();
            if (thisHeight > tallest) {
                tallest = thisHeight;
            }
        });
        group.height(tallest);
    }

    equalHeight($('[data-height="equal"] li'));


    $(window).on('resize', function () {
        delay(function () {

            var width = $('[data-shape="square"]').width();
            $('[data-shape="square"]').height(width);
            equalHeight($('[data-height="equal"] li'));
        }, 500);
        
    });


}

var radioButtonRepair = function () {
    //check status on page load
    $("[data-id='form-selectable-repair'] input[checked]").each(
        function () {
            $(this).closest('label').addClass('selected');
        }
    );


    //Add/Remove checkbox selected class


    $('[data-id="form-selectable-repair"]').find('input[type=checkbox]').on('change', function () {
        if ($(this).is(':checked')) {

            $(this).closest('.m-form-repair-image').addClass('selected');
        }
        else {
            $(this).closest('.m-form-repair-image').removeClass('selected');
        }
    });

    //Add/Remove radio selected class

    $('[data-id="form-selectable-repair"]').find('input[type=radio]').on('change', function () {

        var parentGroup = $(this).closest('[data-id="form-selectable-group"]');

        parentGroup.find('.m-form-repair-image').removeClass("selected");

        if ($(this).is(':checked')) {

            $(this).closest('.m-form-repair-image').addClass('selected');
        }
    });

}

var repairPicture = function () {

    // Detect a change in the input (checkbox)
    $('[data-id="form-selectable-repair"] input').on('change', function () {

        // See if the radio button has been checked
        if ($(this).is(':checked')) {

            $('img').removeClass('m-repairs-selected');
            var imageClass = $(this).data('option');
            $('img.m-repairs-image-' + imageClass).addClass('m-repairs-selected');

        }
    });
 }

var repairCategories = function () {

    // On load check if we need to show the all categories
    $('.m-repairs-extended.show').show();

    // On click show the additional categories
    $('[data-id="category-toggle"]').on('click', function (e) {
        e.preventDefault();
        $('.m-repairs-extended').slideToggle('show');
    });

    // Ensure user can only select from one of the lists

    $('.m-repairs-cat input').on('click', function () {
        $('.m-repairs-cat input').not(this).attr('checked', false);
        $('.m-repairs-cat input').not(this).parent().removeClass('selected');
    });

}

var repairSingleSubmit = function () {
    
    if ($("button[data-button='single-submit']").length) {

        $("button[data-button='single-submit']").on('click', function (e) {
            $(this).addClass('disabled');
            $(this).html('Please wait...');

                $("button[data-button='sibling-disable']").addClass('disabled');
                $("button[data-button='sibling-disable']").attr('disabled', true);

        });

    };

}